import { useState } from "react";
import { useTranslation } from "react-i18next";
import ModalDetailTimeSchedule from "components/apps/MeetingSchedule/Schedule/Modal/DetailTimeSchedule";
import { useMSScheduleDetail, useMSScheduleStatuses } from "queries/meetingSchedule";
import MeetingReminderNotice from "./MeetingReminderNotice";

const MeetingReminderContainer = ({ reminders, onClose }) => {
  const { i18n } = useTranslation();
  const [openScheduleId, setOpenScheduleId] = useState(null);

  const scheduleStatusesLocale = i18n.language?.startsWith("en") ? "en-US" : "id-ID";
  const { data: scheduleStatuses = [] } = useMSScheduleStatuses(scheduleStatusesLocale, {
    enabled: Boolean(openScheduleId),
  });

  const { data: scheduleDetail } = useMSScheduleDetail(openScheduleId, {
    enabled: Boolean(openScheduleId),
  });

  if (!reminders?.length && !openScheduleId) return null;

  return (
    <>
      <div className="fixed bottom-4 right-4 z-[9999] flex flex-col-reverse gap-3 pointer-events-none">
        {reminders.map((reminder) => (
          <MeetingReminderNotice
            key={reminder.schedule_id}
            contactName={reminder.contact_name}
            contactCompany={reminder.contact_company}
            date={reminder.date}
            startTime={reminder.start_time}
            endTime={reminder.end_time}
            onClose={() => onClose(reminder.schedule_id)}
            onClick={() => setOpenScheduleId(reminder.schedule_id)}
          />
        ))}
      </div>

      <ModalDetailTimeSchedule
        open={Boolean(openScheduleId && scheduleDetail)}
        data={scheduleDetail}
        hideDetailTime={() => setOpenScheduleId(null)}
        refetch={() => {}}
        scheduleStatuses={scheduleStatuses}
        scheduleStatusesLocale={scheduleStatusesLocale}
        onScheduleRowPatch={() => {}}
      />
    </>
  );
};

export default MeetingReminderContainer;
